/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useFeatureFlag } from "cms/features/use-feature-flag";

const FeatureFlagGuard = (props) => {
    const children = props?.children;
    const feature = props?.feature;

    const featureEnabled = useFeatureFlag(feature);
    
    if (!featureEnabled) {
        return null;
    }

    return children;
};

FeatureFlagGuard.displayName = "FeatureFlagGuard";
export { FeatureFlagGuard };
